<template>
  <SelectorPanel
    type="mapControls"
    text="Map Controls"
    :force-close="forceClose"
    content-class="hyp-map-controls-card-text pa-0"
    content-wrapper-class="hyp-map-controls-card"
  >
    <SelectorPanelHeader
      type="mapControls"
      title="Map Controls"
      class="pb-2"
      @click-close="handleClickClose"
    >
    </SelectorPanelHeader>

    <MapControls v-if="renderMapControls" />
  </SelectorPanel>
</template>

<script>
import { mapGetters } from "vuex";
import { MODULE_PREFIX_HOME } from "@/store";

export default {
  name: "MapControlsSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
    SelectorPanelHeader: () =>
      import("@/components/common/SelectorPanelHeader"),
    MapControls: () => import("@/components/mapControls/MapControls"),
  },
  data: () => ({
    forceClose: null,
  }),
  computed: {
    ...mapGetters({
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
    }),
    renderMapControls() {
      // To load from pref with any updates user made from any other feature.
      return (
        this.selectorPanel &&
        this.selectorPanel.selected === "mapControls" &&
        this.selectorPanel.visible
      );
    },
  },
  methods: {
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
  },
};
</script>

<style>
.hyp-dialog-content-container.v-card.hyp-map-controls-card {
  background-color: white !important;
}
</style>
<style scoped></style>
